import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Tag, Avatar, Typography, Button } from "antd";
import {
  EnvironmentOutlined,
  TeamOutlined,
  EyeOutlined
} from "@ant-design/icons";
import { MdEdit } from "react-icons/md";

import styled from "styled-components";
import { Organization_GetOne_Response } from "~/common/typescript/apis/OrganizationAPIs";

const { Title, Text } = Typography;

interface OrganizationInfoProps {
  organization?: Organization_GetOne_Response;
}

const OrganizationInfo = ({ organization }: OrganizationInfoProps) => {
  const navigate = useNavigate();

  if (!organization) {
    return null;
  }

  const handleEditOrganization = () => {
    navigate(`/organization/${organization.id}/edit`);
  };

  const handleViewRegistration = () => {
    navigate(`/organization/${organization.id}/registration`);
  };

  return (
    <UI_Wrapper>
      <Row gutter={[16, 16]}>
        {/* Basic Info */}
        <Col span={24}>
          <Card>
            <Row gutter={16} align="middle">
              <Col>
                {organization.avatar ? (
                  <Avatar size={64} src={organization.avatar.previewUrl} />
                ) : (
                  <Avatar size={64} icon={<EnvironmentOutlined />} />
                )}
              </Col>
              <Col flex={1}>
                <Title level={3} style={{ margin: 0 }}>
                  {organization.name}
                  <MdEdit
                    style={{ marginLeft: 8, cursor: 'pointer' }}
                    onClick={handleEditOrganization}
                  />
                </Title>
                <Text type="secondary">{organization.description || 'Chưa có mô tả'}</Text>
                <div style={{ marginTop: 8 }}>
                  <Tag icon={<TeamOutlined />} color="blue">
                    Tối đa {organization.maxNMembers} thành viên
                  </Tag>
                  {organization.taxId && (
                    <Tag color="geekblue" style={{ marginLeft: 8 }}>
                      MST: {organization.taxId}
                    </Tag>
                  )}
                  <Button
                    type="link"
                    icon={<EyeOutlined />}
                    onClick={handleViewRegistration}
                    style={{ marginLeft: 8 }}
                  >
                    Xem thông tin đăng ký
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

      </Row>
    </UI_Wrapper>
  );
};

export default memo(OrganizationInfo);

const UI_Wrapper = styled.div`
  margin-bottom: 24px;
`;